/* src/app/modules/shared/components/header-column/header-column-review-score/header-column-grading-results.component.scss */
app-header-column-grading-results-score {
  display: contents;
}
/*# sourceMappingURL=header-column-grading-results.component.css.map */
